import React, { useEffect, useState, useRef } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Col } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import Button from 'components/ui/Button'
import { FormLink, FormWrapper } from 'components/ui/Form'
import TextField from 'components/ui/TextField'
import { routes } from 'core/const/routes'
import useAuth from 'hooks/useAuth'
import { GoogleLogin } from '@react-oauth/google'
import ReCAPTCHA from 'react-google-recaptcha'

export interface IFormInputs {
  login: string
  password: string
}

export interface IFormGoogle {
  token: string
}

const schema = yup
  .object({
    login: yup.string().min(2).required().label('email'),
    password: yup.string().required().label('password')
  })
  .required()

export type ModalUrlProps = {
  setModalUrl: (value: boolean) => void
}

const FormLogin = ({ setModalUrl }: ModalUrlProps) => {
  const { signIn, loading, logado, signInGoogle, usuario } = useAuth()
  const router = useRouter()
  const [isMobileResolution, setIsMobileResolution] = useState(false)
  const [sizeMobile, setSizeMobile] = useState<number>()
  const [isVerified, setIsVerified] = useState<boolean>(false)
  const [recaptchaToken, setRecaptchaToken] = useState<string>('')
  const idPerfilCliente = '70493d60-1526-46f2-95ee-309e7b2d1b47'

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<IFormInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      login: '',
      password: ''
    }
  })

  const onSubmit = async (data: IFormInputs) => {
    const success = await signIn({
      usuario: data.login,
      senha: data.password,
      recaptchaToken: recaptchaToken
    })

    if (!success) {
      recaptchaRef.current?.reset()
      setIsVerified(false)
    }
  }

  const onLoginGoogle = async (data: IFormGoogle) => {
    await signInGoogle({ token: data.token })
  }

  useEffect(() => {
    const checkResolution = () => {
      const WindowTela = window.innerWidth

      switch (true) {
        case WindowTela <= 490:
          setIsMobileResolution(true)
          break
        case WindowTela <= 768:
          setSizeMobile(400)
          break
        case WindowTela >= 768:
          setIsMobileResolution(false)
          setSizeMobile(500)
          break
        default:
          setIsMobileResolution(false)
          setSizeMobile(500)
          break
      }
    }

    checkResolution() // Check initial resolution
    window.addEventListener('resize', checkResolution) // Add event listener for resize

    return () => {
      window.removeEventListener('resize', checkResolution) // Cleanup event listener on component unmount
    }
  }, [])

  useEffect(() => {
    const userCliente = usuario && usuario.perfil === idPerfilCliente
    if (logado) {
      if (usuario && usuario.usuarioIncompleto && userCliente) {
        router.replace(routes.cadastroAtualizar)
      } else {
        router.replace(routes.minhasConsultorias)
      }
    }
  }, [logado])

  const recaptchaRef = useRef<ReCAPTCHA>(null)

  const handleChange = (token: string | null) => {
    if (token) {
      setRecaptchaToken(token)
      setIsVerified(true)
    }
  }

  function handleExpired() {
    setIsVerified(false)
  }

  return (
    <>
      <h3>Acessar área do cliente</h3>
      <FormWrapper>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Col className="my-3">
            <TextField
              type="email"
              control={control}
              label="Email"
              error={errors.login && 'Campo obrigatório *'}
              name="login"
              className="my-2"
              inputDefauld
            />
          </Col>
          <Col className="my-3">
            <TextField
              control={control}
              label="Senha"
              error={errors.password && 'Campo obrigatório *'}
              name="password"
              type="password"
              className="my-2"
              inputDefauld
            />
          </Col>
          <div className="mt-5 mb-3">
            <div className="d-flex justify-content-center align-items-center">
              <ReCAPTCHA
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ''}
                ref={recaptchaRef}
                onChange={handleChange}
                onExpired={handleExpired}
              />
            </div>
            <Button
              type="submit"
              loading={loading}
              loadingText="Entrando"
              size="large"
              fullWidth
              disabled={!isVerified}
            >
              Acessar
            </Button>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <p>Ou entrar com: </p>

              <GoogleLogin
                width={sizeMobile}
                type={`${isMobileResolution ? 'icon' : 'standard'}`}
                onSuccess={(credentialResponse) => {
                  if (credentialResponse.credential) {
                    const data: IFormGoogle = {
                      token: credentialResponse.credential
                    }
                    onLoginGoogle(data)
                  } else {
                    console.log('token google não encontrado')
                  }
                }}
                onError={() => {
                  console.log('Login Failed')
                }}
                useOneTap
              />
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '20px'
            }}
          >
            <FormLink style={{ float: 'none', margin: 0 }}>
              <Link href={routes.recuperarSenha} title="Redefinir senha">
                <a>Esqueceu sua senha?</a>
              </Link>
            </FormLink>
            <FormLink style={{ float: 'none', margin: 0, fontWeight: 600 }}>
              <Link href={routes.primeiroAcesso} title="Primeiro acesso">
                <a>Primeiro acesso</a>
              </Link>
            </FormLink>
          </div>
        </form>
      </FormWrapper>
    </>
  )
}

export default FormLogin
